import ProgressBar from "@/components/ProgressBar/ProgressBar";
import RootModal from "@/components/RootModal/RootModal";
import Skeleton from "@/components/Skeleton/Skeleton";
import useUrlState from "@/hooks/useUrlState";
import MetricWidget from "../components/MetricWidget/MetricWidget";
import { formatCarbonFootprint } from "../utils/formatters";
import GhgCategoryDetails from "./GhgCategoryDetails";
import { default as ghgStyles, default as styles } from "./GhgDashboard.module.scss";
import { IGetGhg, IScope, IScopeLevel } from "./types";

export default function GhgTableScope({
  scope,
  level,
  data,
  loading,
}: {
  scope: IScope;
  level: IScopeLevel;
  data?: IGetGhg;
  loading?: boolean;
}) {
  const [scopeKey, setScopeKey] = useUrlState("scope_key");

  return (
    <>
      <div
        className={ghgStyles.row}
        onClick={() => setScopeKey(level.key)}
      >
        <div></div>
        <div className={ghgStyles.name}>{level.label}</div>
        <div>
          {loading ? (
            <Skeleton style={{ height: "12px", width: "60px" }} />
          ) : (
            formatCarbonFootprint(data?.[level.key] || 0)
          )}
        </div>
        <div>
          <ProgressBar
            type="grey"
            size="small"
            value={(data?.[level.key] || 0) / (data?.[scope.key] || 1)}
          />
        </div>
      </div>
      <RootModal
        title={scope.label + " - " + level.label}
        onCancel={() => setScopeKey("")}
        footer={null}
        open={scopeKey === level.key}
        wrapperClassName={styles.modal}
        width={1500}
      >
        <MetricWidget
          title={"Impact - " + scope.label + " - " + level.label}
          data={{
            value: data?.[level.key],
            comparison: { label: "% of total carbon impact", value: data?.total },
          }}
          format={formatCarbonFootprint}
        />
        <GhgCategoryDetails category={level.key} />
      </RootModal>
    </>
  );
}
